var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "activityToast" } },
    [
      _c("transition", { attrs: { name: "activity-toast", appear: "" } }, [
        _vm.showing
          ? _c("div", { staticClass: "toast-wrapper" }, [
              _c(
                "div",
                { staticClass: "toast" },
                [
                  _c("div", { staticClass: "message" }, [
                    _vm._v(_vm._s(_vm.message))
                  ]),
                  _vm._v(" "),
                  _vm.route
                    ? _c(
                        "v-btn",
                        {
                          attrs: { block: "", flat: "" },
                          on: { click: _vm.open }
                        },
                        [_vm._v("VIEW")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55285c58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55285c58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityToast.vue
// module id = 446
// module chunks = 4